import script from "./SearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=10a7f671&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10a7f671"]])

export default __exports__